import AdminsDB, { requiredSignInProps } from 'src/firebase/db/Admins';
/**
 * ログイン
 */
export const signIn = ({ email, password }: requiredSignInProps) => {
  return AdminsDB.signIn({ email, password });
};

/**
 * ログアウト
 */
export const signOut = () => {
  return AdminsDB.signOut();
};

/**
 * パスワードリセット
 */
export const sendPasswordReset = (email: string) => {
  return AdminsDB.sendPasswordResetEmail(email);
};

/**
 * ユーザー情報を取得する
 * @param param user_id user_id
 *
 */
export const getUser = (user_id: string) => {
  return AdminsDB.findUser(user_id);
};
